import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Link, themeGet } from '@primer/react';
import styled from 'styled-components';

var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-size: \"14px\";\n  text-underline-offset: 2px;\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-size: \"14px\";\n  text-underline-offset: 2px;\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) {
  return props.color || themeGet("colors.link.default");
}, function (props) {
  return props.hoverColor || themeGet("colors.link.hover");
});
var LTLink = function LTLink(_a) {
  var _b = _a.children,
    children = _b === void 0 ? null : _b,
    _c = _a.href,
    href = _c === void 0 ? "" : _c,
    _d = _a.label,
    label = _d === void 0 ? "" : _d,
    _e = _a.leadingIcon,
    leadingIcon = _e === void 0 ? null : _e,
    _f = _a.muted,
    muted = _f === void 0 ? false : _f,
    _g = _a.showUnderline,
    showUnderline = _g === void 0 ? false : _g,
    _h = _a.style,
    style = _h === void 0 ? {} : _h,
    _j = _a.trailingIcon,
    trailingIcon = _j === void 0 ? null : _j,
    rest = __rest(_a, ["children", "href", "label", "leadingIcon", "muted", "showUnderline", "style", "trailingIcon"]);
  return /*#__PURE__*/React.createElement(StyledLink, __assign({
    href: href,
    muted: muted,
    underline: showUnderline,
    sx: __assign({}, style)
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      marginRight: "6px"
    }
  }, !!leadingIcon && leadingIcon), label ? label : children, !!trailingIcon && trailingIcon);
};
var templateObject_1;

export { LTLink as default };
